// HUB-455: default THANOS_WIDGET_URL to the real sales-ai embed for any
// non-local environment (dev/staging/prod all point at production sales-ai —
// there is no per-env Thanos deployment), while local dev keeps mounting the
// fixture unless a dev explicitly opts into the real widget. Explicit
// REACT_APP_THANOS_WIDGET_URL always wins.
const REACT_APP_ENV = process.env.REACT_APP_ENV || "local";
const THANOS_REAL_WIDGET_URL = "https://sales-ai.oppizi.com/widget/review-v1.js";

const CONFIG = {
  ENV: REACT_APP_ENV,
  API_URL: process.env.REACT_APP_API_URL || "http://localhost:5000",
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || "http://localhost:5000/platform",
  GRAPHQL_API_BASE_URL: process.env.REACT_APP_GRAPHQL_API_BASE_URL || "http://localhost:5000/graphql",
  PATHFINDER_API_BASE_URL: process.env.REACT_APP_PATHFINDER_API_BASE_URL || "http://localhost:5001/graphql",
  FLYER_API_URL: process.env.REACT_APP_FLYER_API_URL || "http://localhost:4001/dev/graphql",
  PLATFORM_BASE_URL: process.env.REACT_APP_PLATFORM_BASE_URL || "http://localhost:3000",
  PAYMENT_BASE_URL: process.env.REACT_APP_PAYMENT_BASE_URL || "http://localhost:9000",
  CRYPTO_SECRET_KEY: process.env.REACT_APP_CRYPTO_SECRET_KEY,
  GOOGLE_API_KEY: process.env.REACT_APP_GOOGLE_API_KEY,
  NEXT_BASE_URL: process.env.REACT_APP_NEXT_BASE_URL || "http://localhost:3001",
  BUILDER_BASE_URL: process.env.REACT_APP_BUILDER_BASE_URL || "http://localhost:3002",
  // Developer API gateway — hosts the Copilot UI-control channel
  // (/copilot/ui/*). Ticket-authed, so no credentials are configured here.
  GATEWAY_BASE_URL: process.env.REACT_APP_GATEWAY_BASE_URL || "http://localhost:3850/dev",
  SHOPIFY_BASE_URL: process.env.REACT_APP_PUBLIC_SHOPIFY_OPPIZI_APP_URL,
  USER_ROLE: {
    ADMIN: "ADMIN",
    CITY_MANAGER: "CITY_MANAGER",
    CLIENT_ADMIN: "CLIENT_ADMIN",
    CLIENT: "ROLE_CLIENT",
    DISTRIBUTOR: "DISTRIBUTOR",
    RECRUITER: "RECRUITER",
    SPY: "ROLE_SPY",
  },
  STORE: {
    USER_KEY: "user",
    API_KEY: "apiKey",
  },
  PDF_FLYER_BUCKET_REGION: process.env.REACT_APP_PDF_FLYER_BUCKET_REGION,
  PDF_FLYER_BUCKET: process.env.REACT_APP_PDF_FLYER_BUCKET,
  // Local/dev override for the `formats_from_api` PostHog flag (print-format catalogue in the design tool).
  FORMATS_FROM_API: process.env.REACT_APP_FORMATS_FROM_API === "true",
  POSTHOG_KEY: process.env.REACT_APP_PUBLIC_POSTHOG_KEY,
  POSTHOG_HOST: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
  // Google reCAPTCHA v2 site key. Intentionally has NO fallback: site keys
  // are domain-bound by Google, so a hardcoded prod key would silently
  // ship to staging/local and either get rejected or warn-flagged by
  // reCAPTCHA when the domain doesn't match. When the env var is unset
  // `isCaptchaRequired()` returns false and the widget is skipped — the
  // signup form still works, just without bot protection. Prod must
  // explicitly set REACT_APP_GOOGLE_CAPTCHA at build time.
  GOOGLE_CAPTCHA: process.env.REACT_APP_GOOGLE_CAPTCHA,
  INTEGRATIONS_SERVICE_BASE_URL: process.env.REACT_APP_INTEGRATIONS_SERVICE_BASE_URL || "http://localhost:4200/dev",
  // HUB-453/HUB-455: review-for-discount offer (epic HUB-440). Real widget
  // shipped in phase 4 (D1/HUB-455) at THANOS_REAL_WIDGET_URL. Defaults to the
  // real embed for every non-local env; local dev mounts the
  // contract-compliant fixture (thanosWidgetFixture.ts) unless explicitly
  // overridden. Set REACT_APP_THANOS_WIDGET_URL to force either path.
  THANOS_WIDGET_URL:
    process.env.REACT_APP_THANOS_WIDGET_URL || (REACT_APP_ENV !== "local" ? THANOS_REAL_WIDGET_URL : ""),
  // Eligibility mock is strictly opt-in (dev only): unset/anything-but-"true"
  // hits the real GET /billing/checkout/review-offer/eligibility (HUB-449), so
  // staging/prod builds can never route offers through the browser mock.
  REVIEW_OFFER_ELIGIBILITY_MOCK: process.env.REACT_APP_REVIEW_OFFER_ELIGIBILITY_MOCK === "true",
  UNSPLASH: {
    unsplashAppId: process.env.REACT_APP_UNSPLASH_APP_ID,
    unsplashUrl: process.env.REACT_APP_UNSPLASH_URL,
    unsplashAccessKey: process.env.REACT_APP_UNSPLASH_ACCESS_KEY,
  },
  PUPPETEER_SERVICE: {
    baseUrl: process.env.REACT_APP_PUPPETEER_SERVICE_URL || "http://localhost:4005",
  },
  STRIPE: {
    PUBLIC_KEY_US: process.env.REACT_APP_PUBLIC_STRIPE_KEY_US,
    PUBLIC_KEY_AU: process.env.REACT_APP_PUBLIC_STRIPE_KEY_AU,
    PUBLIC_KEY_UK: process.env.REACT_APP_PUBLIC_STRIPE_KEY_UK,
    PUBLIC_KEY_FR: process.env.REACT_APP_PUBLIC_STRIPE_KEY_FR,
    PUBLIC_KEY_BE: process.env.REACT_APP_PUBLIC_STRIPE_KEY_BE,
    PUBLIC_KEY_NZ: process.env.REACT_APP_PUBLIC_STRIPE_KEY_NZ,
    PUBLIC_KEY_NL: process.env.REACT_APP_PUBLIC_STRIPE_KEY_NL,
    PUBLIC_KEY_DE: process.env.REACT_APP_PUBLIC_STRIPE_KEY_DE,
    PUBLIC_KEY_ES: process.env.REACT_APP_PUBLIC_STRIPE_KEY_ES,
  },
  AWS: {
    KEY: process.env.REACT_APP_S3_AWS_ACCESS_KEY_ID,
    SECRET: process.env.REACT_APP_S3_AWS_SECRET_ACCESS_KEY,
  },
};

export default CONFIG;
